'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _const = require('../const');
var _const2 = _interopRequireDefault(_const);
var _utils = require('../utils');
var _utils2 = _interopRequireDefault(_utils);
var _bootstrap = require('../contexts/bootstrap');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint
    react/require-default-props: 0
    jsx-a11y/no-noninteractive-element-interactions: 0
  */

var SelectionCell = function (_Component) {
  _inherits(SelectionCell, _Component);
  function SelectionCell() {
    _classCallCheck(this, SelectionCell);
    var _this = _possibleConstructorReturn(this, (SelectionCell.__proto__ || Object.getPrototypeOf(SelectionCell)).call(this));
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _createClass(SelectionCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.selected !== nextProps.selected || this.props.disabled !== nextProps.disabled || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex || this.props.selectColumnStyle !== nextProps.selectColumnStyle;
      return shouldUpdate;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
        inputType = _props.mode,
        rowKey = _props.rowKey,
        selected = _props.selected,
        onRowSelect = _props.onRowSelect,
        disabled = _props.disabled,
        rowIndex = _props.rowIndex;
      e.stopPropagation();
      if (disabled) return;
      var checked = inputType === _const2.default.ROW_SELECT_SINGLE ? true : !selected;
      onRowSelect(rowKey, checked, rowIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props2 = this.props,
        rowKey = _props2.rowKey,
        inputType = _props2.mode,
        selected = _props2.selected,
        disabled = _props2.disabled,
        tabIndex = _props2.tabIndex,
        rowIndex = _props2.rowIndex,
        selectionRenderer = _props2.selectionRenderer,
        selectColumnStyle = _props2.selectColumnStyle;
      var attrs = {};
      if (tabIndex !== -1) attrs.tabIndex = tabIndex;
      attrs.style = _utils2.default.isFunction(selectColumnStyle) ? selectColumnStyle({
        checked: selected,
        disabled: disabled,
        rowIndex: rowIndex,
        rowKey: rowKey
      }) : selectColumnStyle;
      return _react2.default.createElement(_bootstrap.BootstrapContext.Consumer, null, function (_ref) {
        var bootstrap4 = _ref.bootstrap4;
        return _react2.default.createElement('td', _extends({
          className: 'selection-cell',
          onClick: _this2.handleClick
        }, attrs), selectionRenderer ? selectionRenderer({
          mode: inputType,
          checked: selected,
          disabled: disabled,
          rowIndex: rowIndex,
          rowKey: rowKey
        }) : _react2.default.createElement('input', {
          type: inputType,
          checked: selected,
          disabled: disabled,
          className: bootstrap4 ? 'selection-input-4' : '',
          onChange: function onChange() {}
        }));
      });
    }
  }]);
  return SelectionCell;
}(_react.Component);
SelectionCell.propTypes = {
  mode: _propTypes2.default.string.isRequired,
  rowKey: _propTypes2.default.any,
  selected: _propTypes2.default.bool,
  onRowSelect: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  rowIndex: _propTypes2.default.number,
  tabIndex: _propTypes2.default.number,
  clickToSelect: _propTypes2.default.bool,
  selectionRenderer: _propTypes2.default.func,
  selectColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};
exports.default = SelectionCell;